import type { UserCourseAccess } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const adminGrantCourseAccess = async ({
  userId,
  courseId,
  accessStartDate,
  accessEndDate,
}: {
  userId: string;
  courseId: string;
  accessStartDate?: string | null;
  accessEndDate?: string | null;
}) => {
  await privateAPI.post<void>("/user-course-access/admin-grant", {
    user_id: userId,
    course_id: courseId,
    access_start_date: accessStartDate ?? null,
    access_end_date: accessEndDate ?? null,
  });
};

export const getUserCourseAccesses = async (
  page: number,
  userId?: string,
  pageSize?: number,
): Promise<ServiceResponse<UserCourseAccess[]>> => {
  const params: Record<string, unknown> = {
    page,
    include: "course,user",
  };

  if (userId) {
    params["filter[user]"] = userId;
  }

  if (pageSize) {
    params.pageSize = pageSize;
  }

  const { data } = await privateAPI.get<ServiceResponse<UserCourseAccess[]>>(
    "/user-course-access",
    { params },
  );

  return data;
};

export const updateUserCourseAccess = async ({
  userCourseAccessId,
  status,
  accessStartDate,
  accessEndDate,
}: {
  userCourseAccessId: string;
  status: string;
  accessStartDate: string | null;
  accessEndDate: string | null;
}) => {
  await privateAPI.put<void>(`/user-course-access/${userCourseAccessId}`, {
    status,
    access_start_date: accessStartDate,
    access_end_date: accessEndDate,
  });
};
